import React from 'react';
import Card from './EtaCard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTruckMoving } from '@fortawesome/free-solid-svg-icons';
import classes from './EtaChart.module.css';
import { OrderEta } from '../../store/EtaSlice';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

interface EtaChartProps {
    orders: OrderEta[]
}

const EtaChart = (props: EtaChartProps) => {

    const { t, i18n } = useTranslation();

    const chartClass = (status: string) => {
        switch (status) {
            case 'Dispatched':
                return classes.dispatchedYellow;
            case 'Planned':
                return classes.plannedRed;
            case 'Started':
                return classes.startedOrange;
            case 'Delivered':
                return classes.deliveredGreen;
            default:
                return classes.plannedRed;
        }
    }

    if (!props.orders || !props.orders.length) {
        return (
            <div className="col">
                <Card className={classes.noContentBg + " p-2"}>
                    <div className="row">
                        <div className="col text-center">
                            <div> 
                                <FontAwesomeIcon icon={faTruckMoving} size="2x" />
                            </div>
                            <div className={classes.noContentText}>There are no Etas available</div>
                        </div>
                    </div>
                </Card>
            </div>
        )
    }

    return (
        <div className="col justify-content-center">
            {
                props.orders.map((ord: OrderEta, idx: number) => {
                    return (
                        <Card key={idx}>
                            <div className={"row p-0 " + classes.etaRowHeight}>
                                <div className={'col-xs-12 col-md-12 text-center ' + classes.etaHeader}>&nbsp;</div>
                                <div className="d-flex flex-row col-md-12 col-xs-12">
                                    <div className="col-md-5 col-xs-5 pr-0">
                                        <svg viewBox="-3 -2 47 40" className={classes.circularChart + " " + chartClass(ord.orderStatus) + " mr-0 mt-0"}>
                                            <path d="M43 0
                                         l0 35" className={classes.lineBg} />
                                            <path className={classes.circleBg}
                                                d="M18 2.0845
                                    a 15.9155 15.9155 0 0 1 0 31.831
                                    a 15.9155 15.9155 0 0 1 0 -31.831"
                                            />
                                            <path className={classes.circleInner + " " + + chartClass(ord.orderStatus) }
                                                strokeDasharray="100, 100"
                                                d="M18 2.0845
                                    a 15.9155 15.9155 0 0 1 0 31.831
                                    a 15.9155 15.9155 0 0 1 0 -31.831"
                                            />
                                            <text x="18" y="20.35" className={classes.circleText}>{ord.liftGrossQuantity}</text>
                                        </svg>
                                    </div>
                                    <div className="col-md-7 col-xs-7 mt-2 p-0">
                                        <div className={classes.svgText + " mb-2"}>Start: {moment(ord.etaStartDate).format(t('dateTimeFormat'))}</div>
                                        <div className={classes.svgText + " mb-2"}>ETA: +2 hrs</div>
                                        <div className={classes.svgText + " mb-2"}>{ord.productClass2}</div>
                                        <div className={classes.svgText + " mb-2"}>Carrier/Order: {ord.carrierName} {ord.orderNumber}</div>
                                    </div>
                                </div>
                            </div>
                        </Card>
                    );
                })
            }
        </div>
    )
}

export default EtaChart;